import React from 'react';

/**
 * Sample Collection Form for Menopause (Pre or Post) Cycle Phase.
 * SCC KeyPad: PHAZE
 */
const CyclePhase = ({ id, labelText, formField, onChange }) => {
	if (!formField?.accessionKey) {
		return null;
	}

	return (
		<div className={formField.valid === false ? ' has-error' : ''}>
			<label className="control-label" htmlFor={`${id}`}>
				{labelText} <span className="text-danger">*</span>
			</label>
			<select
				className="form-select"
				id={`${id}`}
				onChange={onChange}
				value={formField.value}
				data-accessionkey={formField.accessionKey}
			>
				<option />
				<option value="@Z080">Cycle Phase - Day 21</option>
				<option value="@Z081">Cycle Phase - No Cycle</option>
				<option value="@Z082">Cycle Phase - Post Hysterectomy</option>
				<option value="@Z083">Cycle Phase - Post Hysterectomy & Oophorectomy</option>
				<option value="@Z084">Cycle Phase - Unknown</option>
				<option value="@Z085">Cycle Phase - Male</option>
			</select>
			{formField.valid === false && (
				<span className="validation-message text-danger">Please fill out this field.</span>
			)}
		</div>
	);
};

export default CyclePhase;
